var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStairwell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.624,
    height: 40.186,
    viewBox: "0 0 31.624 40.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19571",
    "data-name": "Group 19571",
    transform: "translate(-265.377 -23.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-stair-6867080",
    transform: "translate(54.572 -53.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247940",
    "data-name": "Path 247940",
    d: "M555.108,229.693a2.027,2.027,0,0,1,.512,1.344v7.511a1.6,1.6,0,0,0,.432,1.108l3,3.279a1.1,1.1,0,0,1,.284.628l.669,6.062v0a.74.74,0,0,1-1.47.1l-.771-5.024a1.85,1.85,0,0,0-.638-1.133l-5.094-4.325a.857.857,0,0,1-.307-.644l-.008-6.016a.738.738,0,0,0-.4-.653.729.729,0,0,0-.754.07c-.5.4-1.48.811-1.407,1.6v5.041a.621.621,0,0,1-.181.44.618.618,0,0,1-.874,0,.621.621,0,0,1-.181-.44V232.47a.666.666,0,0,1,.284-.55l3.538-2.523a2.721,2.721,0,0,1,1.84-.394,2.055,2.055,0,0,1,1.525.691Z",
    transform: "translate(-331.275 -146.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247941",
    "data-name": "Path 247941",
    d: "M612.935,79.256a2.131,2.131,0,1,1,2.108-2.131A2.131,2.131,0,0,1,612.935,79.256Z",
    transform: "translate(-388.867 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247942",
    "data-name": "Path 247942",
    d: "M707.6,502.856l1.44-4.536L711.015,500l-3.475,8.727v0a.861.861,0,0,1-1.116.48.875.875,0,0,1-.5-1.063c.194-.617,1.522-4.784,1.674-5.29Z",
    transform: "translate(-488.7 -405.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247943",
    "data-name": "Path 247943",
    d: "M815.437,604.175l-.59,1.864-5.835,4.222h0a.577.577,0,0,1-.819-.126.605.605,0,0,1-.109-.44.6.6,0,0,1,.236-.387l7.006-5.079h0a.274.274,0,0,1,.11-.055Z",
    transform: "translate(-597.274 -508.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247944",
    "data-name": "Path 247944",
    d: "M211.942,194.772a5.648,5.648,0,0,0-.88-.827l12.321-8.924a.592.592,0,0,1,.691.96Z",
    transform: "translate(18.11 -105.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247945",
    "data-name": "Path 247945",
    d: "M532.775,352.476a.706.706,0,0,1-.96,1.015l-3.277-2.405v-2.194l3.586,3.02C532.191,351.973,532.732,352.411,532.775,352.476Z",
    transform: "translate(-303.407 -262.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247946",
    "data-name": "Path 247946",
    d: "M211.77,680.515h5.363V677.2a.966.966,0,0,1,.967-.965h6.039v-3.712a.972.972,0,0,1,.967-.967h6.235l0-3.933a.964.964,0,0,1,.958-.967h8.7a1.421,1.421,0,0,1,1.423,1.425v15.53a1.667,1.667,0,0,1-1.666,1.666H211.77a.966.966,0,0,1-.965-.967v-2.822a.965.965,0,0,1,.965-.967Z",
    transform: "translate(0 -568.092)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairwell);
export default __webpack_public_path__ + "static/media/stairwell.d26ed5c4f79d71858627cf717fc9b541.svg";
export { ForwardRef as ReactComponent };